import { createScopedRouterHelpers } from "@circle-react/utils/router/createScopedRouterHelpers";

import type { authRouter } from "./AuthenticationAppRouter";

const scopedRouterHelpers = createScopedRouterHelpers<typeof authRouter>();

export const { useScopedNavigate, useScopedParams, useScopedRouteContext } =
  scopedRouterHelpers;
